module.exports = __webpack_public_path__ + "static/media/mentor-equipaje.3889c168.png";